
// FilterList component
const FilterList = ({ label, options, selected, onSelect, onDropUpdate, field, clearSelection }) => {

    return (

        <div className="filter-sidebar__group">

            <h4 className="filter-sidebar__label">{label}</h4>

            <ul className="filter-sidebar__list">

                <li
                    key="All"
                    className={`filter-sidebar__item ${selected === 'All' ? 'filter-sidebar__item--active' : ''}`}
                    onClick={() => onSelect('All')}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                        e.preventDefault();
                        const imageId = e.dataTransfer.getData('text/plain');
                        onDropUpdate(imageId, { [field]: 'None' });
                    }}
                >

                    All

                </li>

                {[...options].sort((a, b) => a.localeCompare(b)).map(opt => (

                    <li
                        key={opt}
                        className={`filter-sidebar__item ${selected === opt ? 'filter-sidebar__item--active' : ''}`}
                        onClick={() => {
                            clearSelection();
                            onSelect(opt);
                        }}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => {
                            e.preventDefault();
                            const imageId = e.dataTransfer.getData('text/plain');
                            onDropUpdate(imageId, { [field]: opt });
                        }}
                    >

                        {opt}

                    </li>

                ))}

            </ul>

        </div>

    );

};



// FilterSidebar component
const FilterSidebar = ({ filters, currentFilters, setFilters, onDropUpdate, clearSelection }) => {

    return (

        <div className="filter-sidebar">

            <FilterList
                label="Type"
                options={filters.types}
                selected={currentFilters.typeFilter}
                onSelect={setFilters.setTypeFilter}
                onDropUpdate={onDropUpdate}
                field="type"
                clearSelection={clearSelection}
            />

            <FilterList
                label="Category"
                options={filters.categories}
                selected={currentFilters.categoryFilter}
                onSelect={setFilters.setCategoryFilter}
                onDropUpdate={onDropUpdate}
                field="category"
                clearSelection={clearSelection}
            />

            <FilterList
                label="Subcategory"
                options={filters.subcategories}
                selected={currentFilters.subcategoryFilter}
                onSelect={setFilters.setSubcategoryFilter}
                onDropUpdate={onDropUpdate}
                field="subcategory"
                clearSelection={clearSelection}
            />

        </div>

    );

};

export default FilterSidebar;

